import React from "react";

export default function MediaHeader({ title }) {
  return (
    <header>
      <h1 className="text-left font-outfit text-[24px] font-medium leading-[30.24px] text-[#222222]">
        {title}
      </h1>
    </header>
  );
}
